<template>
  <div class="body">
    <Home-Header :navindex="1"></Home-Header>
    <!-- <Home-Nav :navindex="0"></Home-Nav> -->
    <Home-Swiper :slideindex="1"></Home-Swiper>
    <div class="content-wrapper">
      <Home-Bookkeeping></Home-Bookkeeping>
      <Home-QJZ2022></Home-QJZ2022>
      <Home-Paperlessprocesses ></Home-Paperlessprocesses>
      <Home-Services></Home-Services>
    </div>
    <Home-Safe></Home-Safe>
    <Home-Floatbar></Home-Floatbar>
    <Home-Footer></Home-Footer>
    <Home-Footerfrom></Home-Footerfrom>
    <a id="newBridge-left"  href="http://pkt.zoosnet.net/LR/Chatpre.aspx?id=PKT58642380&lng=cn"  rel='nofollow' target="_blank" ></a>

  </div>
</template>

<script>
import HomeHeader from '../common/Header'
import HomeSwiper from '../common/Swiper'
import HomeBookkeeping from './components/Bookkeeping'
import HomePaperlessprocesses from '../home/components/Paperlessprocesses'
import HomeQJZ2022 from './components/QJZ2022'
import HomeServices from './components/Services'
import HomeSafe from '../common/Safe'
import HomeFloatbar from '../common/Floatbar'
import HomeFooter from '../common/Footer'
import HomeFooterfrom from '../common/Footerfrom'
export default {
  name: 'Product',
  metaInfo: {
    title: '会计代理记账-上海机巧科技有限公司',
    meta: [
      { name: 'keywords', content: '企业代理记账_上海代理记账_记账代理' },
      { name: 'description', content: '机巧科技专业代理公司注册、代理记账及税收筹划。为中小企业提供优质的公司注册、代理记账报税、筹划及公司注销等服务机巧科技专业代理公司注册、代理记账及税收筹划。为中小企业提供优质的公司注册、代理记账报税、纳税筹划及公司注销等服务.' }
    ]
  },
  components: {
    HomeHeader, HomeSwiper, HomeBookkeeping, HomeServices, HomeSafe, HomeFloatbar, HomeFooter, HomeFooterfrom, HomeQJZ2022, HomePaperlessprocesses
  },
  data () {
    return {
      list1: [],
      list2: [],
      list3: []
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
.content-wrapper{
  margin-top: 72px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Product/Product.vue